const Loading = () => {
  return (
    <div className="lds-ripple z-50">
      <div></div>
      <div></div>
    </div>
  );
};

export default Loading;
